import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	eapLozengeTitle: {
		id: 'servicedesk-insight-reports-v2.preference-banner.eap-lozenge-title',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'EAP',
		description: 'EAP lozenge title',
	},
	bannerTitle: {
		id: 'servicedesk-insight-reports-v2.preference-banner.banner-title',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Try the new Assets dashboards available on your site and give us <feedbackLink>your feedback</feedbackLink>. To access your existing reports, return to the <previousExperienceLink>previous experience</previousExperienceLink>.',
		description: 'Banner title',
	},
});
